export default function(course_list) {
  let courseAux = "";
  if (course_list) {
    if (typeof course_list === "string") courseAux = course_list;
    else if (!course_list?.title) {
      for (let c = 0; c < course_list.length; c++) {
        const course = course_list[c];
        if (c === course_list.length - 1) courseAux += course.title;
        else courseAux += `${course.title}, `;
      }
    } else courseAux = course_list.title;
  }
  return courseAux;
}
